(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mel-catalog-product"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-catalog-product]').forEach(root => {
    if (root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    const parse = selector => { try { return JSON.parse(root.querySelector(selector)?.textContent || 'null'); } catch { return null; } };
    const config = parse('[data-catalog-content]') || {};
    config.images = Array.isArray(config.images) ? config.images : [];
    config.styles = Array.isArray(config.styles) ? config.styles : [];
    const variants = parse('[data-mel-variants]') || [];
    const track = root.querySelector('[data-mel-gallery-track]');
    const slides = [...root.querySelectorAll('[data-mel-slide]')];
    const thumbs = [...root.querySelectorAll('[data-mel-thumb]')];
    const box = root.querySelector('[data-catalog-lightbox]');
    root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !dialog.open) return;
      const items = [...dialog.querySelectorAll('button:not([disabled]), a[href], summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter(item => item.getClientRects().length > 0);
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    }));
    let active = 0;
    let opener;
    const caption = i => config.images.find(x => String(x.media_id).split('/').pop() === slides[i]?.dataset.mediaId)?.caption || slides[i]?.querySelector('img')?.alt || '';
    const announce = i => {
      active = Math.max(0, Math.min(i, slides.length - 1));
      root.querySelector('[data-catalog-caption]').textContent = caption(active);
      root.querySelector('[data-catalog-counter]').textContent = `${slides.length ? active + 1 : 0} / ${slides.length}`;
      root.querySelector('[data-mel-gallery-prev]').disabled = active === 0;
      root.querySelector('[data-mel-gallery-next]').disabled = active >= slides.length - 1;
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === active)));
    };
    const showMedia = id => {
      const i = slides.findIndex(x => x.dataset.mediaId === String(id));
      if (i < 0) return;
      track.scrollTo({left: track.clientWidth * i, behavior: 'instant'});
      announce(i);
    };
    const form = root.querySelector('.mel-product-form');
    const variantInput = root.querySelector('[data-mel-variant-input]');
    const groups = [...root.querySelectorAll('[data-mel-option-group]')];
    const choices = [...root.querySelectorAll('[data-mel-option-choice]')];
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: window.Shopify?.currency?.active || 'USD'});
    const readOptions = () => groups.map(group => group.querySelector(':checked')?.value);
    const sync = (updateUrl = true) => {
      const selected = readOptions();
      const variant = groups.length ? variants.find(v => v.options.every((value, i) => value === selected[i])) : variants[0];
      variantInput.value = variant ? String(variant.id) : '';
      variantInput.disabled = !variant;
      const available = Boolean(variant?.available);
      root.querySelectorAll('[data-mel-add]').forEach(button => { button.disabled = !available; });
      root.querySelectorAll('[data-mel-add-label], [data-mel-sticky-label]').forEach(label => {
        label.textContent = available ? label.dataset.availableLabel : label.dataset.soldLabel;
      });
      root.querySelectorAll('[data-mel-sticky-option]').forEach(label => { label.textContent = groups.length ? selected.join(' / ') : label.dataset.defaultLabel; });
      groups.forEach((group, i) => { const label = group.querySelector('[data-mel-selected-option]'); if (label) label.textContent = selected[i] || ''; });
      choices.forEach(input => {
        const i = Number(input.dataset.melOptionPosition) - 1;
        const exists = variants.some(v => v.options[i] === input.value && v.options.every((value, j) => j === i || value === selected[j]));
        input.setAttribute('aria-disabled', String(!exists));
      });
      const price = root.querySelector('[data-mel-price]');
      price.textContent = variant ? money.format(variant.price / 100) : '—';
      const compare = root.querySelector('[data-mel-compare-price]');
      compare.hidden = !(variant?.compare_at_price > variant?.price);
      compare.textContent = compare.hidden ? '' : money.format(variant.compare_at_price / 100);
      if (updateUrl) {
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
      const style = config.styles.find(s => selected[Number(s.option_position || 1) - 1] === s.option_value);
      const mediaId = style?.media_id || variant?.featured_media?.id || variant?.featured_image?.id;
      if (mediaId) showMedia(String(mediaId).split('/').pop());
    };
    root.addEventListener('change', event => { if (event.target.matches('[data-mel-option-choice]')) sync(); });
    root.querySelector('[data-mel-gallery-prev]').addEventListener('click', () => showMedia(slides[active - 1]?.dataset.mediaId));
    root.querySelector('[data-mel-gallery-next]').addEventListener('click', () => showMedia(slides[active + 1]?.dataset.mediaId));
    thumbs.forEach((button, i) => button.addEventListener('click', () => showMedia(slides[i]?.dataset.mediaId)));
    track.addEventListener('scroll', () => announce(Math.round(track.scrollLeft / (track.clientWidth || 1))), {passive: true});
    root.querySelectorAll('[data-catalog-select]').forEach(button => button.addEventListener('click', () => {
      const style = config.styles.find(x => String(x.id) === button.dataset.catalogSelect);
      const input = choices.find(x => Number(x.dataset.melOptionPosition) === Number(style?.option_position || 1) && x.value === style?.option_value);
      if (input) { input.checked = true; sync(); }
      root.querySelector('.mel-option-groups')?.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      root.querySelector('[data-mel-option-choice]:checked')?.focus({preventScroll: true});
    }));
    const open = (id, target) => {
      const i = slides.findIndex(x => x.dataset.mediaId === String(id));
      if (i < 0) return;
      const img = slides[i].querySelector('img');
      const large = box.querySelector('[data-catalog-large]');
      const url = new URL(img.currentSrc || img.src); url.searchParams.set('width', '1600');
      large.src = url.href; large.alt = img.alt;
      box.querySelector('[data-catalog-large-caption]').textContent = caption(i);
      opener = target; box.showModal(); box.querySelector('button').focus();
    };
    root.querySelector('[data-catalog-zoom]').addEventListener('click', event => { if (slides[active]) open(slides[active].dataset.mediaId, event.currentTarget); });
    root.querySelectorAll('[data-catalog-media]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); open(link.dataset.catalogMedia, link); }));
    box.querySelector('[data-catalog-close]').addEventListener('click', () => box.close());
    box.addEventListener('click', event => { if (event.target === box) box.close(); });
    box.addEventListener('close', () => opener?.focus({preventScroll: true}));
    const materialBox = root.querySelector('[data-mel-material-dialog]');
    const materialTrigger = root.querySelector('[data-mel-material-open]');
    materialTrigger.addEventListener('click', () => { materialBox.showModal(); materialBox.querySelector('[data-mel-material-close]').focus(); });
    materialBox.querySelector('[data-mel-material-close]').addEventListener('click', () => materialBox.close());
    materialBox.addEventListener('click', event => { if (event.target === materialBox) materialBox.close(); });
    materialBox.addEventListener('close', () => materialTrigger.focus({preventScroll: true}));
    let quantity = 1;
    const changeQuantity = delta => {
      quantity = Math.max(1, Math.min(Number(root.dataset.quantityLimit) || 10, quantity + delta));
      root.querySelector('[data-mel-quantity]').textContent = String(quantity);
      root.querySelector('[data-mel-quantity-input]').value = String(quantity);
    };
    root.querySelector('[data-mel-quantity-minus]').addEventListener('click', () => changeQuantity(-1));
    root.querySelector('[data-mel-quantity-plus]').addEventListener('click', () => changeQuantity(1));
    const wishKey = `mel-wishlist-${root.dataset.productHandle}`;
    let wished = false;
    try { wished = localStorage.getItem(wishKey) === 'true'; } catch {}
    const renderWish = () => root.querySelectorAll('[data-mel-wishlist]').forEach(button => button.setAttribute('aria-pressed', String(wished)));
    root.querySelectorAll('[data-mel-wishlist]').forEach(button => button.addEventListener('click', () => { wished = !wished; try { localStorage.setItem(wishKey, String(wished)); } catch {} renderWish(); }));
    renderWish();
    root.querySelector('[data-mel-scroll-options]').addEventListener('click', () => {
      (groups[0] || form).scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      choices.find(input => input.checked)?.focus({preventScroll: true});
    });
    const sticky = root.querySelector('[data-mel-sticky-cart]');
    const primary = root.querySelector('[data-mel-primary-add]');
    if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    }).observe(primary);
    const footer = document.querySelector('.mel-site-chrome--footer, .mel-footer');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { root.dataset.catalogFooterVisible = String(entry.isIntersecting); }).observe(footer);
    }
    form.addEventListener('submit', event => {
      if (form.dataset.submitting === 'true' || !variants.some(v => String(v.id) === variantInput.value && v.available)) { event.preventDefault(); return; }
      form.dataset.submitting = 'true'; form.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => { delete form.dataset.submitting; form.removeAttribute('aria-busy'); sync(); });
    window.addEventListener('popstate', () => {
      const variant = variants.find(v => String(v.id) === new URL(location.href).searchParams.get('variant'));
      if (variant) choices.forEach(input => { input.checked = variant.options[Number(input.dataset.melOptionPosition) - 1] === input.value; });
      sync(false);
    });
    sync(false); announce(active);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mel-connection-product"]) return;
  try {
    
(() => {
  const mount = (scope = document) => {
    scope.querySelectorAll('[data-connection-product]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const one = s => root.querySelector(s);
      const all = s => [...root.querySelectorAll(s)];
      const labels = JSON.parse(one('[data-ck-labels]').textContent);
      const variants = JSON.parse(one('[data-ck-variants]').textContent);
      const pdp = JSON.parse(one('[data-ck-pdp]').textContent);
      const pairEnabled = one('[data-ck-pair-enabled]');
      const pairSelect = one('[data-ck-pair-variant]');
      const thumbs = all('[data-ck-thumb]');
      const image = one('.ck-main-image');
      const mediaDialog = one('[data-ck-media-dialog]');
      const fitDialog = one('[data-ck-fit-dialog]');
      const quickDialog = one('[data-ck-quickbuy]');
      const confirmation = one('[data-ck-confirmation]');
      const formPlaceholder = one('[data-ck-form-placeholder]');
      const dialogStates = new Map();
      const lightbox = one('[data-ck-lightbox]');
      const contactView = one('[data-ck-contact-view]');
      const zoomImage = one('[data-ck-zoom-image]');
      const zoomScroll = one('.ck-zoom-scroll');
      const form = one('.ck-form');
      const addButton = one('[data-ck-add]');
      const buyNowButton = one('[data-ck-buy-now]');
      let checkoutPending = false;
      let receiptSequence = 0;
      let offerBusy = false;
      const quantity = one('[data-ck-quantity]');
      let currentIndex = Number(root.dataset.initialIndex) || 0;
      let selected = variants.find(v => String(v.id) === one('[data-ck-variant-id]').value) || variants[0];

      let busy = false;
      let syncSticky = () => {};
      if (root.dataset.isPreview === 'true') { all('[data-ck-cart-link], [data-ck-receipt-link]').forEach(link => {const url = new URL(link.href, document.baseURI);url.searchParams.set('preview_theme_id',root.dataset.previewThemeId);link.href=url.href;}); }
      const formatMoney = cents => new Intl.NumberFormat(root.dataset.locale || 'en-US', {style: 'currency', currency: root.dataset.currency || 'USD'}).format(cents / 100);
      const stickyLabel = () => {
        if (busy) return labels.adding;
        const second = variants.find(v => String(v.id) === pairSelect.value);
        if (!selected.available || (pairEnabled.checked && !second?.available)) return labels.unavailable;
        const count = Math.max(1, Math.min(99, Math.trunc(Number(quantity.value)) || 1));
        const total = pairEnabled.checked ? selected.price + second.price : selected.price * count;
        const action = pairEnabled.checked ? labels.pairAdd : count > 1 ? labels.addMany.replace('[count]',count) : labels.add;
        return action + ' · ' + formatMoney(total);
      };
      const resetZoom = () => {
        zoomScroll.classList.remove('is-zoomed');
        one('[data-ck-zoom-toggle]').setAttribute('aria-pressed', 'false');
        one('[data-ck-zoom-toggle]').textContent = labels.zoomIn;
      };
      const photoOwners = {0:0,1:0,2:0,3:0,4:0,5:0,6:0,9:0,10:10,11:10,12:10,14:14,15:15};
      const setImage = (index, scrollThumb = true, selectStyle = true) => {
        if (busy) return;
        currentIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[currentIndex];
        const meta = thumb.dataset;
        const owner = thumbs.length === 21 ? photoOwners[currentIndex] : undefined;
        if (selectStyle && owner !== undefined) {
          const radio = all('[data-ck-style]').find(el => Number(el.dataset.imageIndex) === owner);
          if (radio && !radio.checked) {radio.checked = true;updateVariant(radio, true, false);}
        }
        image.src = meta.stageSrc;
        image.srcset = [360,540,720,960,1200].map(width => {
          const url = new URL(meta.stageSrc, document.baseURI);
          url.searchParams.set('width', width);
          return `${url.href} ${width}w`;
        }).join(', ');
        image.alt = meta.imageAlt;
        all('[data-ck-index]').forEach(el => el.textContent = currentIndex + 1);
        all('[data-ck-caption]').forEach(el => el.textContent = meta.caption);
        thumbs.forEach((el, i) => el.setAttribute('aria-current', String(i === currentIndex)));
        if (scrollThumb) {
          const strip = one('.ck-thumbnails');
          const x = thumb.offsetLeft - strip.offsetLeft;
          if (x < strip.scrollLeft || x + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({left: Math.max(0, x - strip.clientWidth / 2 + thumb.offsetWidth / 2), behavior:'auto'});
        }
        if (mediaDialog.open && !lightbox.hidden) {
          zoomImage.src = meta.fullSrc;
          zoomImage.alt = meta.imageAlt;
          resetZoom();
        }
      };
      const openDialog = dialog => {
        if (dialog.open) return;
        dialogStates.set(dialog, {opener:document.activeElement, overflow:document.body.style.overflow});
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      };
      [mediaDialog, fitDialog, quickDialog, confirmation].forEach(dialog => {
        dialog.querySelector('[data-ck-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => {
          const saved = dialogStates.get(dialog);
          document.body.style.overflow = all('dialog[open]').length ? 'hidden' : (saved?.overflow === 'hidden' ? '' : saved?.overflow || '');
          if (saved?.opener?.isConnected && !all('dialog[open]').length) saved.opener.focus({preventScroll:true});
          else if (saved?.opener?.isConnected && saved.opener.closest('dialog[open]')) saved.opener.focus({preventScroll:true});
          syncSticky();
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
      const restoreForm = () => {
        if (form.parentElement === formPlaceholder.parentElement) return;
        formPlaceholder.insertAdjacentElement('afterend', form);
        formPlaceholder.hidden = true;
        formPlaceholder.style.height = '';
        syncSticky();
      };
      quickDialog.addEventListener('close', restoreForm);
      quickDialog.addEventListener('cancel', event => {if (busy) event.preventDefault();});
      const revealPairChoice = () => {
        if (!pairEnabled.checked) return;
        requestAnimationFrame(() => {
          const choice = pairSelect.getBoundingClientRect();
          const behavior = matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth';
          if (quickDialog.open) {
            const limit = one('.ck-purchase-actions').getBoundingClientRect().top - 20;
            if (choice.bottom > limit) quickDialog.scrollTop += choice.bottom-limit;
          } else if (choice.bottom > innerHeight - 24 || choice.top < 96) {
            pairSelect.scrollIntoView({block:'center',behavior});
          }
        });
      };
      fitDialog.addEventListener('close', () => {if (quickDialog.open) revealPairChoice();});
      const openQuickBuy = () => {
        if (quickDialog.open) return;
        formPlaceholder.style.height = form.getBoundingClientRect().height + 'px';
        formPlaceholder.hidden = false;
        one('[data-ck-quick-host]').append(form);
        openDialog(quickDialog);
        quickDialog.scrollTop = 0;
        one('[data-ck-style]:checked').focus({preventScroll:true});
        revealPairChoice();
      };
      one('[data-ck-continue]').addEventListener('click', () => confirmation.close());
      one('[data-ck-checkout-form]').addEventListener('submit', event => {
        if (offerBusy || event.currentTarget.dataset.submitting || event.currentTarget.hidden || one('[data-ck-receipt-checkout]').disabled) {event.preventDefault();return;}
        event.currentTarget.dataset.submitting = 'true';
        one('[data-ck-receipt-checkout]').disabled = true;
        one('[data-ck-receipt-checkout]').textContent = labels.checkoutLoading;
      });
      const cartMoney = (cents, currency) => new Intl.NumberFormat(root.dataset.locale || 'en-US', {style:'currency',currency:currency || root.dataset.currency || 'USD'}).format(cents / 100);
      const setOfferStatus = message => all('[data-ck-offer-status]').forEach(el => {el.textContent=message;el.hidden=!message;});
      const offerFeedback = (cart, attempted = false) => {
        const code = pdp.offer?.code;
        if (!code) return;
        const count = cart.items.reduce((total,item) => total + (variants.some(v => String(v.id) === String(item.variant_id || item.id)) ? item.quantity : 0), 0);
        const accepted = cart.discount_codes?.some(discount => discount.code?.toLowerCase() === code.toLowerCase() && discount.applicable);
        const allocated = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(entry => entry.discount_application))].some(discount => discount?.title?.toLowerCase() === code.toLowerCase());
        const applied = accepted || allocated;
        let message = applied ? labels.offerApplied.replace('[total]',cartMoney(cart.total_price,cart.currency)) : count < 3 ? (3-count === 1 ? labels.offerMoreOne : labels.offerMore.replace('[count]',3-count)) : attempted ? labels.offerUnavailable : labels.offerReady;
        setOfferStatus(message.replace('[code]',code));
        const offer = one('[data-ck-receipt-offer]');
        if (offer) {
          offer.hidden = cart.item_count === 0 || applied;
          offer.querySelector('[data-ck-offer-apply]').hidden = count < 3;
        }
      };
      const renderCartItems = cart => {
        const list = one('[data-ck-added-items]');
        list.replaceChildren();
        cart.items.forEach(item => {
          const radio = all('[data-ck-style]').find(el => el.value === String(item.variant_id || item.id));
          const li = document.createElement('li');
          const thumb = document.createElement('img');
          const src = item.featured_image?.url || item.image;
          if (src) { const url=new URL(src,document.baseURI);url.searchParams.set('width','180');thumb.src=url.href; }
          thumb.alt = radio?.dataset.label || item.product_title || item.title;
          thumb.width=76;thumb.height=76;
          const detail = document.createElement('div');
          const name = document.createElement('strong');
          name.textContent = radio?.dataset.label || item.title;
          const qty = document.createElement('span');
          qty.textContent = labels.quantityLabel + ': ' + item.quantity;
          detail.append(name,qty);
          const amount = document.createElement('strong');
          amount.className = 'ck-receipt-unit';
          const total = Number.isFinite(item.final_line_price) ? item.final_line_price : item.line_price;
          if (item.original_line_price > total) {const original=document.createElement('s');original.textContent=cartMoney(item.original_line_price,cart.currency);amount.append(original);}
          amount.append(document.createTextNode(cartMoney(total,cart.currency)));
          const label = document.createElement('small');label.textContent=labels.lineTotal;amount.append(label);
          if (src) li.append(thumb);
          li.append(detail,amount);list.append(li);
        });
      };
      const paintReceipt = (cart, currentItems, offerAttempted = false) => {
        document.querySelectorAll('.mel-cart-link > span').forEach(badge => {badge.textContent=String(cart.item_count);});
        const empty = cart.item_count === 0;
        if (currentItems) {
          one('[data-ck-cart-status]').textContent='';
          one('[data-ck-cart-link]').hidden=empty;
        }
        confirmation.dataset.empty = String(empty);
        one('[data-ck-receipt-empty]').hidden = !empty;
        one('[data-ck-receipt-empty]').textContent = empty ? labels.emptyNote : '';
        one('[data-ck-receipt-context]').hidden = empty;
        one('[data-ck-added-items]').hidden = empty;
        one('.ck-added-total').hidden = empty;
        one('[data-ck-receipt-note]').hidden = empty;
        one('[data-ck-checkout-form]').hidden = empty;
        one('[data-ck-receipt-link]').hidden = empty;
        one('[data-ck-receipt-checkout]').disabled = empty || offerBusy || !!one('[data-ck-checkout-form]').dataset.submitting;
        if (empty || currentItems) {
          one('[data-ck-receipt-heading]').textContent = empty ? labels.emptyTitle : labels.cartTitle;
          one('[data-ck-receipt-context]').textContent = labels.currentItems;
          renderCartItems(cart);
        }
        one('[data-ck-receipt-total-label]').textContent = labels.cartSubtotal + ' · ' + cart.item_count + ' ' + labels.items;
        one('[data-ck-added-total]').textContent = cartMoney(cart.total_price,cart.currency);
        one('[data-ck-cart-savings]').hidden = !(cart.total_discount > 0);
        one('[data-ck-cart-savings]').textContent = cart.total_discount > 0 ? labels.cartSavings + ' ' + cartMoney(cart.total_discount,cart.currency) : '';
        one('[data-ck-receipt-note]').textContent = labels.cartNote;
        offerFeedback(cart,offerAttempted);
        confirmation.setAttribute('aria-busy','false');
      };
      const refreshCartSummary = async (sequence, currentItems = false) => {
        if (currentItems) {
          confirmation.setAttribute('aria-busy','true');
          one('[data-ck-receipt-heading]').textContent=labels.cartTitle;
          one('[data-ck-receipt-empty]').hidden=false;
          one('[data-ck-receipt-empty]').textContent=labels.cartUpdating;
          one('[data-ck-receipt-context]').hidden=true;
          one('[data-ck-added-items]').hidden=true;
          one('.ck-added-total').hidden=true;
          one('[data-ck-cart-savings]').hidden=true;
          one('[data-ck-receipt-note]').hidden=true;
          if (one('[data-ck-receipt-offer]')) one('[data-ck-receipt-offer]').hidden=true;
          one('[data-ck-checkout-form]').hidden=true;
          one('[data-ck-receipt-checkout]').disabled=true;
        }
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{'Accept':'application/json'},cache:'no-store',signal:AbortSignal.timeout(8000)});
          if (!response.ok) throw new Error('cart');
          const cart = await response.json();
          if (sequence !== receiptSequence) return;
          if (!Number.isFinite(cart.total_price) || !Number.isFinite(cart.item_count) || !Array.isArray(cart.items)) throw new Error('cart');
          paintReceipt(cart,currentItems);
        } catch {
          if (sequence !== receiptSequence) return;
          confirmation.setAttribute('aria-busy','false');
          if (currentItems) {
            one('[data-ck-receipt-empty]').hidden=false;
            one('[data-ck-receipt-empty]').textContent=labels.cartRefreshError;
            one('[data-ck-receipt-link]').hidden=false;
          }
        }
      };
      all('[data-ck-offer-apply]').forEach(link => link.addEventListener('click', async event => {
        event.preventDefault();
        if (busy || offerBusy || !pdp.offer?.code) return;
        offerBusy=true;
        one('[data-ck-receipt-checkout]').disabled=true;
        all('[data-ck-offer-apply]').forEach(el => el.setAttribute('aria-disabled','true'));
        setOfferStatus(labels.offerApplying.replace('[code]',pdp.offer.code));
        updatePurchase();
        const sequence=++receiptSequence;
        try {
          const response=await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:pdp.offer.code}),signal:AbortSignal.timeout(8000)});
          const cart=await response.json();
          if (!response.ok || !Array.isArray(cart.items)) throw new Error('offer');
          if (sequence !== receiptSequence) return;
          if (confirmation.open) paintReceipt(cart,true,true);
          else offerFeedback(cart,true);
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        } catch {
          setOfferStatus(labels.offerError.replace('[code]',pdp.offer.code));
        } finally {
          offerBusy=false;
          one('[data-ck-receipt-checkout]').disabled=confirmation.dataset.empty === 'true' || !!one('[data-ck-checkout-form]').dataset.submitting;
          all('[data-ck-offer-apply]').forEach(el => el.removeAttribute('aria-disabled'));
          updatePurchase();
        }
      }));
      const filterGallery = group => {
        all('[data-ck-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ckFilter === group)));
        let count = 0;
        all('[data-ck-contact-image]').forEach(tile => {
          tile.hidden = group !== 'all' && tile.dataset.group !== group;
          if (!tile.hidden) count += 1;
        });
        one('[data-ck-filter-count]').textContent = `${count} / ${thumbs.length}`;
      };
      const showSingle = index => {
        lightbox.hidden = false;
        contactView.hidden = true;
        one('[data-ck-gallery-mode]').textContent = labels.allImages;
        openDialog(mediaDialog);
        setImage(index, false);
        mediaDialog.scrollTop = 0;
      };
      const showGallery = (group = 'all') => {
        lightbox.hidden = true;
        contactView.hidden = false;
        one('[data-ck-gallery-mode]').textContent = labels.singleImage;
        filterGallery(group);
        openDialog(mediaDialog);
        mediaDialog.scrollTop = 0;
      };
      all('[data-ck-enlarge]').forEach(button => button.addEventListener('click', () => showSingle(currentIndex)));
      all('[data-ck-open-gallery]').forEach(button => button.addEventListener('click', () => showGallery(button.dataset.ckOpenGallery || 'all')));
      thumbs.forEach((button,index) => button.addEventListener('click', () => setImage(index)));
      all('[data-ck-prev]').forEach(button => button.addEventListener('click', () => setImage(currentIndex - 1, !mediaDialog.open)));
      all('[data-ck-next]').forEach(button => button.addEventListener('click', () => setImage(currentIndex + 1, !mediaDialog.open)));
      all('[data-ck-contact-image]').forEach(button => button.addEventListener('click', () => showSingle(Number(button.dataset.ckContactImage))));
      all('[data-ck-show-image]').forEach(button => button.addEventListener('click', () => showSingle(Number(button.dataset.ckShowImage))));
      all('[data-ck-filter]').forEach(button => button.addEventListener('click', () => filterGallery(button.dataset.ckFilter)));
      one('[data-ck-gallery-mode]').addEventListener('click', () => lightbox.hidden ? showSingle(currentIndex) : showGallery());
      one('[data-ck-zoom-toggle]').addEventListener('click', event => {
        const zoomed = zoomScroll.classList.toggle('is-zoomed');
        event.currentTarget.setAttribute('aria-pressed', String(zoomed));
        event.currentTarget.textContent = zoomed ? labels.zoomOut : labels.zoomIn;
      });
      const galleryKeys = event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (mediaDialog.open && lightbox.hidden) return;
        event.preventDefault();
        setImage(currentIndex + (event.key === 'ArrowRight' ? 1 : -1), !mediaDialog.open);
      };
      one('.ck-gallery').addEventListener('keydown', galleryKeys);
      mediaDialog.addEventListener('keydown', galleryKeys);
      const updatePurchase = () => {
        const second = variants.find(v => String(v.id) === pairSelect.value);
        const isPair = pairEnabled.checked;
        const count = isPair ? 2 : Math.max(1, Math.min(99, Math.trunc(Number(quantity.value)) || 1));
        const total = isPair ? selected.price + (second?.price || 0) : selected.price * count;
        const selectedRadio = one('[data-ck-style]:checked');
        const selectedThumb = thumbs[Number(selectedRadio.dataset.imageIndex)];
        const summary = count === 1 ? labels.oneBracelet : count + ' ' + labels.bracelets;
        one('[data-ck-sticky-style]').textContent = isPair ? labels.pairAdd.replace(/^Add /, '') : selectedRadio.dataset.label;
        one('[data-ck-sticky-summary]').textContent = summary;
        one('[data-ck-sticky-total]').textContent = formatMoney(total);
        one('[data-ck-sticky-image]').src = selectedThumb.querySelector('img').src;
        one('[data-ck-quick-style]').textContent = isPair ? summary : selectedRadio.dataset.label;
        one('[data-ck-quick-total]').textContent = formatMoney(total);
        one('[data-ck-back-to-style]').disabled = busy;
        one('[data-ck-quick-image]').src = selectedThumb.querySelector('img').src;
        one('[data-ck-heading]').textContent = selectedRadio.dataset.heading || pdp.heading;
        one('[data-ck-selected-detail]').textContent = selectedRadio.dataset.material;
        form.setAttribute('aria-busy', String(busy));
        all('[data-ck-style], [data-ck-pair-enabled], [data-ck-pair-variant], [data-ck-quantity], [data-ck-quantity-step]').forEach(el => el.disabled = busy);
        quickDialog.querySelector('[data-ck-close]').disabled = busy;
        const canBuy = selected.available && (!isPair || second?.available);
        const secondRadio = all('[data-ck-style]').find(el => el.value === pairSelect.value);
        one('[data-ck-pair-panel]').hidden = !isPair;
        one('[data-ck-quantity-wrap]').hidden = isPair;
        one('[data-ck-pair-first]').textContent = one('[data-ck-style]:checked').dataset.label;
        one('[data-ck-pair-total]').textContent = formatMoney(selected.price + (second?.price || 0));
        one('[data-ck-pair-image]').src = thumbs[Number(secondRadio.dataset.imageIndex)].querySelector('img').src;
        one('[data-ck-pair-image]').alt = secondRadio.dataset.label;
        one('[data-ck-piece-note]').textContent = isPair ? labels.pairNote : labels.singleNote;
        const text = !canBuy ? labels.unavailable : stickyLabel();
        one('[data-ck-purchase-summary]').hidden = count < 2 || isPair;
        one('[data-ck-purchase-count]').textContent = summary;
        all('[data-ck-quantity-step]').forEach(button => {
          const step = Number(button.dataset.ckQuantityStep);
          button.disabled = busy || (step < 0 && count <= 1) || (step > 0 && count >= 99);
        });
        addButton.disabled = !canBuy || busy || offerBusy;
        buyNowButton.disabled = !canBuy || busy || offerBusy;
        buyNowButton.textContent = busy && checkoutPending ? labels.checkoutLoading : labels.buyNow;
        addButton.textContent = busy ? labels.adding : text;
        const stickyAdd = one('[data-ck-sticky-add]');
        stickyAdd.disabled = !canBuy || busy || offerBusy;
        stickyAdd.textContent = stickyLabel();
        syncSticky();
      };
      const updateVariant = (radio, updateUrl = true, updateImage = true) => {
        const next = variants.find(v => String(v.id) === radio.value);
        if (!next) return;
        selected = next;
        one('[data-ck-variant-id]').value = selected.id;
        all('[data-ck-price]').forEach(el => el.textContent = formatMoney(selected.price));
        const compare = one('[data-ck-compare]');
        compare.hidden = !(selected.compare_at_price > selected.price);
        compare.textContent = compare.hidden ? '' : formatMoney(selected.compare_at_price);
        const discounted = selected.compare_at_price > selected.price;
        const saving = selected.compare_at_price - selected.price;
        one('[data-ck-sale]').hidden = !discounted;
        one('[data-ck-sale]').textContent = discounted ? Math.round(saving * 100 / selected.compare_at_price) + '% ' + labels.sale : '';
        one('[data-ck-savings]').textContent = discounted ? labels.save + ' ' + formatMoney(saving) + ' · ' : '';
        updatePurchase();
        one('[data-ck-availability]').hidden = selected.available;
        one('[data-ck-sku]').textContent = selected.sku;
        one('[data-ck-material]').textContent = radio.dataset.material || '';

        one('[data-ck-cart-status]').textContent = '';
        one('[data-ck-cart-link]').hidden = true;
        if (updateImage) setImage(Number(radio.dataset.imageIndex), true, false);
        if (updateUrl && location.protocol !== 'about:') {
          const url = new URL(location.href);
          url.searchParams.set('variant', selected.id);
          if (root.dataset.isPreview === 'true' && root.dataset.previewThemeId) url.searchParams.set('preview_theme_id', root.dataset.previewThemeId);
          history.replaceState({}, '', url);
        }
      };
      all('[data-ck-style]').forEach(radio => radio.addEventListener('change', () => updateVariant(radio)));
      pairEnabled.addEventListener('change', () => {updatePurchase();revealPairChoice();});
      pairSelect.addEventListener('change', updatePurchase);
      all('a[href="#ck-pair"]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        if (busy || offerBusy) return;
        pairEnabled.checked=true;
        updatePurchase();
        if (matchMedia('(max-width:800px)').matches) openQuickBuy();
        else one('#ck-pair').scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        pairSelect.focus({preventScroll:true});
        revealPairChoice();
      }));
      all('[data-ck-select-variant]').forEach(button => button.addEventListener('click', () => {
        const radio = all('[data-ck-style]').find(el => el.value === button.dataset.ckSelectVariant);
        radio.checked = true;
        updateVariant(radio);
        one('.ck-style-fieldset').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
        radio.focus({preventScroll:true});
      }));
      one('[data-ck-sticky-add]').addEventListener('click', () => {if (!busy) form.requestSubmit(addButton);});
      updateVariant(one('[data-ck-style]:checked'), false, false);
      if (root.dataset.isPreview === 'true') window.addEventListener('load', () => updateVariant(one('[data-ck-style]:checked'), true, false), {once:true});
      all('[data-ck-caption]').forEach(el => el.textContent = thumbs[currentIndex].dataset.caption);
      const clampQuantity = () => {
        const value = Math.trunc(Number(quantity.value));
        quantity.value = Math.max(1, Math.min(99, Number.isFinite(value) ? value : 1));
      };
      quantity.addEventListener('input', updatePurchase);
      quantity.addEventListener('change', () => {clampQuantity();updatePurchase();});
      all('[data-ck-quantity-step]').forEach(button => button.addEventListener('click', () => {
        quantity.value = Number(quantity.value) + Number(button.dataset.ckQuantityStep);
        clampQuantity();
        updatePurchase();
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (addButton.disabled || busy) return;
        clampQuantity();
        checkoutPending = event.submitter === buyNowButton;
        let navigating = false;
        const submittedItems = pairEnabled.checked ? [{id:selected.id,quantity:1},{id:Number(pairSelect.value),quantity:1}] : [{id:selected.id,quantity:Number(quantity.value)}];
        busy = true;
        updatePurchase();
        const status = one('[data-ck-cart-status]');
        status.textContent = '';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:submittedItems})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || labels.error);
          if (checkoutPending) {
            navigating = true;
            const checkoutForm = document.createElement('form');
            checkoutForm.method = 'post';
            checkoutForm.action = `${window.Shopify?.routes?.root || '/'}cart`;
            const checkoutInput = document.createElement('input');
            checkoutInput.type = 'hidden';
            checkoutInput.name = 'checkout';
            checkoutInput.value = 'checkout';
            checkoutForm.append(checkoutInput);
            document.body.append(checkoutForm);
            checkoutForm.submit();
            return;
          }
          status.textContent = labels.added;
          one('[data-ck-cart-link]').hidden = false;
          const added = new Map();
          submittedItems.forEach(item => added.set(String(item.id), (added.get(String(item.id)) || 0) + item.quantity));
          const list = one('[data-ck-added-items]');
          list.replaceChildren();
          let itemsTotal = 0;
          added.forEach((count, id) => {
            const variant = variants.find(v => String(v.id) === id);
            const radio = all('[data-ck-style]').find(r => r.value === id);
            const li = document.createElement('li');
            const thumb = document.createElement('img');
            thumb.src = thumbs[Number(radio.dataset.imageIndex)].querySelector('img').src;
            thumb.alt = radio.dataset.label;
            thumb.width = 76; thumb.height = 76;
            const detail = document.createElement('div');
            const name = document.createElement('strong'); name.textContent = radio.dataset.label;
            const qty = document.createElement('span'); qty.textContent = labels.quantityLabel + ': ' + count;
            const amount = document.createElement('strong'); amount.className = 'ck-receipt-unit';amount.textContent = formatMoney(variant.price);
            const each = document.createElement('small'); each.textContent = labels.each;amount.append(each);
            detail.append(name, qty); li.append(thumb, detail, amount); list.append(li);
            itemsTotal += variant.price * count;
          });
          confirmation.dataset.empty='false';
          one('[data-ck-receipt-heading]').textContent=labels.added;
          one('[data-ck-receipt-context]').textContent=labels.justAdded;
          one('[data-ck-receipt-context]').hidden=false;
          one('[data-ck-receipt-empty]').hidden=true;
          list.hidden=false;
          one('.ck-added-total').hidden=false;
          one('[data-ck-receipt-note]').hidden=false;
          one('[data-ck-checkout-form]').hidden=false;
          one('[data-ck-receipt-link]').hidden=false;
          if (one('[data-ck-receipt-offer]')) one('[data-ck-receipt-offer]').hidden=true;
          receiptSequence += 1;
          one('[data-ck-receipt-total-label]').textContent = labels.itemsTotal;
          one('[data-ck-added-total]').textContent = formatMoney(itemsTotal);
          one('[data-ck-cart-savings]').hidden = true;
          one('[data-ck-receipt-note]').textContent = labels.discountNote;
          delete one('[data-ck-checkout-form]').dataset.submitting;
          one('[data-ck-receipt-checkout]').disabled = false;
          refreshCartSummary(receiptSequence);
          if (quickDialog.open) { quickDialog.close(); restoreForm(); }
          openDialog(confirmation);
          one('[data-ck-receipt-checkout]').focus({preventScroll:true});
          document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        } catch (error) {
          status.textContent = error.message || labels.error;
          status.setAttribute('tabindex','-1'); status.focus({preventScroll:true});
          status.scrollIntoView({block:'nearest'});
        } finally {
          if (!navigating) {busy = false;checkoutPending = false;updatePurchase();}
        }
      });
      const measure = one('[data-ck-measure]');
      const unit = one('[data-ck-unit]');
      const fitResult = one('[data-ck-fit-result]');
      const minFit = Number(root.dataset.fitMin);
      const maxFit = Number(root.dataset.fitMax);
      const measurement = () => {
        const value = measure.value.trim().replace(',', '.');
        return /^\d+(\.\d+)?$/.test(value) ? Number(value) : NaN;
      };
      const updateFit = () => {
        fitResult.removeAttribute('data-status');
        one('[data-ck-fit-use]').hidden = true;
        one('[data-ck-fit-check]').hidden = false;
        measure.removeAttribute('aria-invalid');
        if (!measure.value.trim()) {fitResult.textContent = labels.fitEmpty;return;}
        const value = measurement();
        if (!Number.isFinite(value) || value <= 0 || value > (unit.value === 'cm' ? 40 : 16)) {
          fitResult.textContent = labels.fitInvalid;
          fitResult.dataset.status = 'invalid';
          measure.setAttribute('aria-invalid','true');
          return;
        }
        const cm = unit.value === 'in' ? value * 2.54 : value;
        const inside = cm >= minFit - .04 && cm <= maxFit + .04;
        const roundedInchRange = unit.value === 'in' && value >= Math.round(minFit / 2.54 * 10) / 10 && value <= Math.round(maxFit / 2.54 * 10) / 10;
        if (!inside && roundedInchRange) {
          fitResult.textContent = labels.fitBoundary.replace('[min]', minFit).replace('[max]', maxFit);
          fitResult.dataset.status = 'boundary';
          return;
        }
        fitResult.textContent = inside ? labels.fitInside : labels.fitOutside;
        fitResult.dataset.status = inside ? 'inside' : 'outside';
        one('[data-ck-fit-use]').hidden = !inside;
        one('[data-ck-fit-check]').hidden = inside;
      };
      one('[data-ck-fit-use]').addEventListener('click', () => {
        if (fitResult.dataset.status !== 'inside') return;
        const value = measurement();
        one('[data-ck-fit-summary]').textContent = value + ' ' + (unit.value === 'in' ? 'in' : 'cm') + ' · ' + labels.fitSaved;
        one('[data-ck-fit-summary]').dataset.checked = 'true';
        fitDialog.close();
      });
      all('[data-ck-fit-open]').forEach(button => button.addEventListener('click', () => {openDialog(fitDialog);updateFit();}));
      ['input','change','blur'].forEach(event => measure.addEventListener(event,updateFit));
      measure.addEventListener('keydown',event => {if(event.key==='Enter'){event.preventDefault();updateFit();}});
      one('[data-ck-fit-check]').addEventListener('click',updateFit);
      unit.addEventListener('change', () => {
        if (measure.value.trim()) {
          const current = measurement();
          if (Number.isFinite(current)) measure.value = String(Math.round((unit.value === 'in' ? current / 2.54 : current * 2.54) * 100) / 100);
        }
        measure.placeholder = unit.value === 'cm' ? labels.placeholderCm : labels.placeholderIn;
        updateFit();
      });
      const sticky = one('[data-ck-sticky]');
      syncSticky = () => {
        if (quickDialog.open || confirmation.open || mediaDialog.open || fitDialog.open) {sticky.hidden = true;return;}
        const rect = addButton.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const visible = rect.top >= 0 && rect.bottom <= viewportHeight;
        const before = rect.top >= viewportHeight;
        const mobile = matchMedia('(max-width:800px)').matches;
        sticky.hidden = visible || (!mobile && one('.ck-heading').getBoundingClientRect().bottom > 0);
        const button = one('[data-ck-sticky-add]');
        button.dataset.mode = before ? 'choose' : 'add';
        const second = variants.find(v => String(v.id) === pairSelect.value);
        const canBuy = selected.available && (!pairEnabled.checked || second?.available);
        button.disabled = !canBuy || busy || offerBusy;
        button.textContent = stickyLabel();
      };
      window.addEventListener('pageshow', event => {
        if (event.persisted) {
          busy = false;
          checkoutPending = false;
          delete one('[data-ck-checkout-form]').dataset.submitting;
          one('[data-ck-receipt-checkout]').textContent = labels.checkout;
          updatePurchase();
        }
        if (!busy && !offerBusy) refreshCartSummary(++receiptSequence,true);
      });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && !busy && !offerBusy) refreshCartSummary(++receiptSequence,true);
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(syncSticky,{threshold:[0,1]});
        observer.observe(addButton);
        observer.observe(one('.ck-heading'));
      }
      window.addEventListener('resize', () => {if (!matchMedia('(max-width:800px)').matches && quickDialog.open && !busy) quickDialog.close();syncSticky();},{passive:true});
      syncSticky();
      one('[data-ck-fit-jump]').addEventListener('click', () => {
        one('[data-ck-fit-calculator]').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
        measure.focus({preventScroll:true});
      });
      const stage = one('.ck-stage');
      let touchStart = null;
      let swipedAt = 0;
      stage.addEventListener('touchstart', event => {
        if(event.touches.length === 1) touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY};
      },{passive:true});
      stage.addEventListener('touchend', event => {
        if(!touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touchStart.x;
        const dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if(Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)*1.3){setImage(currentIndex + (dx < 0 ? 1 : -1));swipedAt=Date.now();}
      },{passive:true});
      stage.addEventListener('click',event => {if(Date.now()-swipedAt<400){event.preventDefault();event.stopImmediatePropagation();}},true);
      one('[data-ck-back-to-style]').addEventListener('click', () => {
        if (matchMedia('(max-width:800px)').matches) {openQuickBuy();return;}
        one('.ck-style-fieldset').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
        one('[data-ck-style]:checked').focus({preventScroll:true});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), {once:true});
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mel-designer-page"]) return;
  try {
    
  (() => {
    const observers = new Map();
    const initialize = () => {
      document.querySelectorAll('[data-mel-designer-page]').forEach((page) => {
        if (observers.has(page)) return;
        const header = document.querySelector('[data-mel-header]');
        if (!header) return;
        const resize = () => page.style.setProperty('--mel-designer-header-height', `${header.offsetHeight}px`);
        resize();
        const observer = new ResizeObserver(resize);
        observer.observe(header);
        observers.set(page, observer);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:unload', (event) => {
      observers.forEach((observer, page) => {
        if (!event.target.contains(page)) return;
        observer.disconnect();
        observers.delete(page);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mel-lunar-tide-product"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-lunar-product]').forEach(root => {
    if (root.dataset.lunarReady) return;
    root.dataset.lunarReady = 'true';
    const config = JSON.parse(root.querySelector('[data-lunar-content]').textContent);
    const variants = JSON.parse(root.querySelector('[data-mel-variants]').textContent);
    const track = root.querySelector('[data-mel-gallery-track]');
    const slides = [...root.querySelectorAll('[data-mel-slide]')];
    const thumbs = [...root.querySelectorAll('[data-mel-thumb]')];
    const box = root.querySelector('[data-lunar-lightbox]');
    // Keep keyboard navigation inside this product's open dialogs.
    root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !dialog.open) return;
      const items = [...dialog.querySelectorAll('button:not([disabled]), a[href], summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter(item => item.getClientRects().length > 0);
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    }));
    let active = 0;
    let opener;
    const caption = i => config.images.find(x => x.media_id.split('/').pop() === slides[i]?.dataset.mediaId)?.caption || slides[i]?.querySelector('img')?.alt || '';
    const announce = i => {
      active = Math.max(0, Math.min(i, slides.length - 1));
      root.querySelector('[data-lunar-caption]').textContent = caption(active);
      root.querySelector('[data-lunar-counter]').textContent = `${active + 1} / ${slides.length}`;
      root.querySelector('[data-mel-gallery-prev]').disabled = active === 0;
      root.querySelector('[data-mel-gallery-next]').disabled = active === slides.length - 1;
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === active)));
    };
    const showMedia = id => {
      const i = slides.findIndex(x => x.dataset.mediaId === String(id));
      if (i < 0) return;
      track.scrollTo({left: track.clientWidth * i, behavior: 'instant'});
      announce(i);
    };
    const sync = () => {
      const id = root.querySelector('[data-mel-variant-input]').value;
      const style = config.styles.find(x => x.id === id);
      if (!style) return;
      showMedia(style.media_id.split('/').pop());
    };
    root.addEventListener('change', event => { if (event.target.matches('[data-mel-option-choice]')) sync(); });
    track.addEventListener('scroll', () => announce(Math.round(track.scrollLeft / (track.clientWidth || 1))), {passive: true});
    root.querySelectorAll('[data-lunar-select]').forEach(button => button.addEventListener('click', () => {
      const variant = variants.find(x => String(x.id) === button.dataset.lunarSelect);
      root.querySelectorAll('[data-mel-option-choice]').forEach(input => {
        if (variant?.options[Number(input.dataset.melOptionPosition) - 1] === input.value) input.click();
      });
      root.querySelector('.mel-option-groups').scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      root.querySelector('[data-mel-option-choice]:checked')?.focus({preventScroll: true});
    }));
    const open = (id, target) => {
      const i = slides.findIndex(x => x.dataset.mediaId === String(id));
      if (i < 0) return;
      const img = slides[i].querySelector('img');
      const large = box.querySelector('[data-lunar-large]');
      const url = new URL(img.currentSrc || img.src); url.searchParams.set('width', '1600');
      large.src = url.href; large.alt = img.alt;
      box.querySelector('[data-lunar-large-caption]').textContent = caption(i);
      opener = target; box.showModal(); box.querySelector('button').focus();
    };
    root.querySelector('[data-lunar-zoom]').addEventListener('click', event => open(slides[active].dataset.mediaId, event.currentTarget));
    root.querySelectorAll('[data-lunar-media]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); open(link.dataset.lunarMedia, link); }));
    box.querySelector('[data-lunar-close]').addEventListener('click', () => box.close());
    box.addEventListener('click', event => { if (event.target === box) box.close(); });
    box.addEventListener('close', () => opener?.focus({preventScroll: true}));
    const form = root.querySelector('.mel-product-form');
    const footer = document.querySelector('.mel-site-chrome--footer, .mel-footer');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { root.dataset.lunarFooterVisible = String(entry.isIntersecting); }).observe(footer);
    }
    form.addEventListener('submit', event => {
      if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
      form.dataset.submitting = 'true'; form.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => { delete form.dataset.submitting; form.removeAttribute('aria-busy'); sync(); });
    sync(); announce(active);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mel-standard-product"]) return;
  try {
    
(() => {
  const mount = (scope = document) => {
    scope.querySelectorAll('[data-ms-product]').forEach(root => {
      if (root.dataset.ready) return;
      const one = selector => root.querySelector(selector);
      const all = selector => Array.from(root.querySelectorAll(selector));
      let supplied, variants, labels;
      try {
        supplied = JSON.parse(one('[data-ms-config]').textContent);
        variants = JSON.parse(one('[data-ms-variants]').textContent);
        labels = JSON.parse(one('[data-ms-labels]').textContent);
      } catch { return; }
      if (!Array.isArray(variants) || !variants.length || !labels) return;
      const supported = ['mel-standard/1.0', 'mel-standard/1.1'].includes(supplied?.schema_version);
      const pdp = supported ? {...supplied} : {};
      pdp.variants = Array.isArray(pdp.variants) ? pdp.variants : [];
      pdp.fit = pdp.fit && typeof pdp.fit === 'object' ? pdp.fit : {kind: 'details'};
      pdp.heading ||= one('[data-ms-heading]').textContent;
      pdp.unit ||= labels.per_item;
      pdp.quantity_unit ||= labels.item;
      pdp.included ||= '';
      root.dataset.ready = 'true';
      const form = one('.ms-form');
      const nativeSelect = one('[data-ms-native-select]');
      const quantity = one('[data-ms-quantity]');
      const thumbs = all('[data-ms-thumb]');
      const quick = one('[data-ms-quick]');
      const fit = one('[data-ms-fit]');
      const gallery = one('[data-ms-gallery-dialog]');
      const receipt = one('[data-ms-cart]');
      const openers = new Map();
      const originalOverflow = document.body.style.overflow;
      const money = (cents, currency = root.dataset.currency) => new Intl.NumberFormat(root.dataset.locale || 'en', {style: 'currency', currency: currency || 'USD'}).format(Number(cents) / 100);
      const path = endpoint => root.dataset.root.replace(/\/?$/, '/') + endpoint;
      const currentVariant = () => variants.find(v => String(v.id) === nativeSelect.value);
      const getInfo = variant => pdp.variants.find(v => v.variant_id === String(variant?.id));
      const quantityValue = () => /^\d+$/.test(quantity.value) && Number.isSafeInteger(Number(quantity.value)) && Number(quantity.value) > 0 ? Number(quantity.value) : null;
      let imageIndex = Math.max(0, thumbs.findIndex(t => t.dataset.msThumb === root.dataset.initialMedia));
      let busy = false;
      let cartBusy = false;
      let cartSequence = 0;
      let lastCart = null;
      let gridBuilt = false;
      let zoomed = false;
      let activeFilter = 'all';
      let fitCm = null;
      let fitIsInside = false;
      const purchaseBlocked = pdp.release_guard?.blocked === true || root.dataset.purchaseBlocked === 'true';

      const openDialog = dialog => {
        if (dialog.open) return;
        openers.set(dialog, document.activeElement);
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      };
      const closeDialog = dialog => { if (dialog.open) dialog.close(); };
      all('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          if (dialog === quick) one('[data-ms-form-home]').after(form);
          if (!all('dialog').some(d => d.open)) document.body.style.overflow = originalOverflow;
          const opener = openers.get(dialog);
          if (opener?.isConnected) opener.focus({preventScroll: true});
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
        });
      });
      all('[data-ms-close]').forEach(button => button.addEventListener('click', () => closeDialog(button.closest('dialog'))));

      const showImage = (index, updateSource = true) => {
        if (!thumbs.length) return;
        imageIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[imageIndex];
        const mainImage = one('.ms-main-image');
        const stageUrl = new URL(thumb.dataset.stageSrc, document.baseURI);
        stageUrl.searchParams.set('width', String(Math.min(1400, Math.max(540, Math.ceil(one('.ms-stage').clientWidth * Math.min(devicePixelRatio || 1, 2))))));
        if (updateSource && mainImage.dataset.mediaId !== thumb.dataset.msThumb) {
          mainImage.src = stageUrl.href;
          mainImage.removeAttribute('srcset');
        }
        mainImage.dataset.mediaId = thumb.dataset.msThumb;
        mainImage.alt = thumb.dataset.caption;
        const purpose = thumb.dataset.purpose;
        one('[data-ms-caption]').textContent = purpose && purpose !== 'Product view' ? `${purpose} · ${thumb.dataset.caption}` : thumb.dataset.caption;
        one('[data-ms-active-note]').textContent = thumb.dataset.note || '';
        one('[data-ms-image-note]').hidden = !pdp.image_note || pdp.image_note === thumb.dataset.note || pdp.image_note === thumb.dataset.caption;
        one('[data-ms-index]').textContent = String(imageIndex + 1);
        thumbs.forEach(t => t.setAttribute('aria-current', String(t === thumb)));
        const strip = one('.ms-thumbs');
        const thumbRect = thumb.getBoundingClientRect(), stripRect = strip.getBoundingClientRect();
        if (thumbRect.left < stripRect.left) strip.scrollLeft += thumbRect.left - stripRect.left;
        else if (thumbRect.right > stripRect.right) strip.scrollLeft += thumbRect.right - stripRect.right;
        if (gallery.open && !one('[data-ms-gallery-single]').hidden) one('[data-ms-full-image]').src = thumb.dataset.fullSrc;
        one('[data-ms-full-image]').alt = thumb.dataset.caption;
        one('[data-ms-dialog-caption]').textContent = thumb.dataset.caption;
        one('[data-ms-dialog-note]').textContent = thumb.dataset.note || pdp.image_note || '';
        one('[data-ms-dialog-count]').textContent = `${imageIndex + 1} / ${thumbs.length}`;
        zoomed = false;
        one('.ms-zoom-viewport').dataset.zoom = 'false';
        one('[data-ms-zoom-toggle]').textContent = labels.zoom_in;
      };
      const setGrid = active => {
        one('[data-ms-gallery-single]').hidden = active;
        one('[data-ms-gallery-grid]').hidden = !active;
        one('[data-ms-zoom-toggle]').hidden = active;
        one('[data-ms-gallery-mode]').textContent = active ? labels.single_image : labels.grid;
        if (!active && gallery.open) one('[data-ms-full-image]').src = thumbs[imageIndex].dataset.fullSrc;
        if (!gridBuilt && active) {
          thumbs.forEach((thumb, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.group = thumb.dataset.group;
            const img = document.createElement('img');
            const url = new URL(thumb.dataset.stageSrc, document.baseURI);
            url.searchParams.set('width', '440');
            img.src = url.href; img.alt = ''; img.width = 440; img.height = 440; img.loading = 'lazy';
            const caption = document.createElement('span'); caption.textContent = `${index + 1}. ${thumb.dataset.caption}`;
            button.append(img, caption);
            button.addEventListener('click', () => { showImage(index); setGrid(false); one('[data-ms-zoom-toggle]').focus(); });
            one('[data-ms-grid-host]').append(button);
          });
          const groups = new Set(thumbs.map(t => t.dataset.group));
          all('[data-ms-filter]').forEach(button => { button.hidden = button.dataset.msFilter !== 'all' && !groups.has(button.dataset.msFilter); });
          gridBuilt = true;
        }
        all('[data-ms-grid-host] > button').forEach(button => { button.hidden = activeFilter !== 'all' && button.dataset.group !== activeFilter; });
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
      all('[data-ms-prev], [data-ms-dialog-prev]').forEach(button => button.addEventListener('click', () => showImage(imageIndex - 1)));
      all('[data-ms-next], [data-ms-dialog-next]').forEach(button => button.addEventListener('click', () => showImage(imageIndex + 1)));
      all('[data-ms-enlarge]').forEach(button => button.addEventListener('click', () => { setGrid(false); openDialog(gallery); showImage(imageIndex); }));
      all('[data-ms-gallery-open]').forEach(button => button.addEventListener('click', () => { setGrid(true); openDialog(gallery); }));
      one('[data-ms-gallery-mode]').addEventListener('click', () => setGrid(!one('[data-ms-gallery-single]').hidden));
      one('[data-ms-zoom-toggle]').addEventListener('click', () => { zoomed = !zoomed; one('.ms-zoom-viewport').dataset.zoom = String(zoomed); one('[data-ms-zoom-toggle]').textContent = zoomed ? labels.zoom_out : labels.zoom_in; });
      all('[data-ms-filter]').forEach(button => button.addEventListener('click', () => {
        activeFilter = button.dataset.msFilter;
        all('[data-ms-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        setGrid(true);
      }));
      gallery.addEventListener('keydown', event => {
        if (one('[data-ms-gallery-single]').hidden) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); showImage(imageIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showImage(imageIndex + 1); }
      });

      const paintSelection = (variant, changeImage = true, updateUrl = true) => {
        if (!/^https?:$/.test(location.protocol)) updateUrl = false;
        const info = getInfo(variant);
        const qty = quantityValue();
        const available = !!variant?.available && !purchaseBlocked;
        if (variant) {
          nativeSelect.value = String(variant.id);
          all('[data-ms-option]').forEach(input => { input.checked = variant.options[Number(input.dataset.msOption)] === input.value; });
          all('[data-ms-option-group]').forEach(group => { group.querySelector('[data-ms-option-name]').textContent = variant.options[Number(group.dataset.msOptionGroup)] || ''; });
          one('[data-ms-heading]').textContent = info?.heading || pdp.heading;
          one('[data-ms-price]').textContent = money(variant.price);
          const sale = Number(variant.compare_at_price) > variant.price;
          one('[data-ms-compare]').hidden = !sale;
          one('[data-ms-compare]').textContent = sale ? money(variant.compare_at_price) : '';
          one('[data-ms-save]').textContent = sale ? `${labels.save} ${money(variant.compare_at_price - variant.price)}` : '';
          one('[data-ms-selection-note]').textContent = info?.description || variant.title;
          one('[data-ms-unit-label]').textContent = info?.unit || pdp.unit;
          one('[data-ms-quantity-unit]').textContent = pdp.quantity_unit;
          one('[data-ms-included]').textContent = info?.included || pdp.included;
          one('[data-ms-sticky-label]').textContent = variant.title === 'Default Title' ? pdp.heading : variant.title;
          const total = qty ? money(variant.price * qty) : '—';
          one('[data-ms-selection-total]').textContent = total;
          one('[data-ms-sticky-total]').textContent = total;
          one('[data-ms-sticky-quantity]').textContent = `${labels.quantity}: ${qty || '—'}`;
          one('[data-ms-quick-summary]').textContent = `${variant.title === 'Default Title' ? pdp.heading : variant.title} · ${money(variant.price)} · ${info?.unit || pdp.unit}`;
          const mediaId = info?.media_id || String(variant.featured_media?.id || '');
          if (changeImage && mediaId) { const index = thumbs.findIndex(t => t.dataset.msThumb === mediaId); if (index >= 0) showImage(index); }
          if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState(history.state, '', url.href); }
        } else {
          nativeSelect.value = '';
          one('[data-ms-selection-note]').textContent = labels.no_combination;
          one('[data-ms-price]').textContent = '—';
          one('[data-ms-compare]').hidden = true;
          one('[data-ms-save]').textContent = '';
          one('[data-ms-selection-total]').textContent = '—';
          one('[data-ms-sticky-total]').textContent = '—';
          one('[data-ms-sticky-label]').textContent = labels.no_combination;
          one('[data-ms-sticky-quantity]').textContent = `${labels.quantity}: ${qty || '—'}`;
          one('[data-ms-quick-summary]').textContent = labels.no_combination;
          if (updateUrl) { const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState(history.state, '', url.href); }
        }
        all('[data-ms-option]').forEach(input => {
          const chosen = all('[data-ms-option-group]').map(group => group.querySelector('input:checked')?.value);
          chosen[Number(input.dataset.msOption)] = input.value;
          const unavailable = !variants.some(v => v.available && v.options.every((value, i) => value === chosen[i]));
          input.dataset.unavailable = String(unavailable);
          input.closest('label').querySelector('.ms-option-unavailable').hidden = !unavailable;
        });
        one('[data-ms-unavailable]').hidden = available || purchaseBlocked;
        one('[data-ms-add]').disabled = busy || !available || !qty;
        one('[data-ms-add]').textContent = busy ? labels.adding : purchaseBlocked ? labels.pending_confirmation : available ? labels.add : labels.unavailable;
        one('[data-ms-buy-now]').disabled = busy || !available || !qty;
        one('[data-ms-buy-now]').textContent = busy ? labels.adding : labels.buy_now;
        one('[data-ms-minus]').disabled = busy || !qty || qty <= 1;
        one('[data-ms-plus]').disabled = busy;
        quantity.disabled = busy;
        all('[data-ms-option]').forEach(input => { input.disabled = busy; });
        if (!qty && !busy) one('[data-ms-status]').textContent = labels.quantity_invalid;
        else if (one('[data-ms-status]').textContent === labels.quantity_invalid) one('[data-ms-status]').textContent = '';
      };
      all('[data-ms-option]').forEach(input => input.addEventListener('change', () => {
        const selected = all('[data-ms-option-group]').map(group => group.querySelector('input:checked')?.value);
        const variant = variants.find(v => v.options.every((value, i) => value === selected[i]));
        one('[data-ms-status]').textContent = '';
        paintSelection(variant);
      }));
      nativeSelect.addEventListener('change', () => paintSelection(currentVariant()));
      quantity.addEventListener('input', () => paintSelection(currentVariant(), false, false));
      one('[data-ms-minus]').addEventListener('click', () => { quantity.value = String(Math.max(1, (quantityValue() || 1) - 1)); paintSelection(currentVariant(), false, false); });
      one('[data-ms-plus]').addEventListener('click', () => { quantity.value = String((quantityValue() || 1) + 1); paintSelection(currentVariant(), false, false); });
      const quickBuy = () => { one('[data-ms-quick-host]').append(form); openDialog(quick); };
      const returnToBuy = () => {
        if (matchMedia('(max-width:800px)').matches) quickBuy();
        else { one('.ms-buy').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'start'}); one('[data-ms-add]').focus({preventScroll: true}); }
      };
      one('[data-ms-quick-open]').addEventListener('click', quickBuy);
      all('[data-ms-return-buy]').forEach(button => button.addEventListener('click', returnToBuy));
      all('[data-ms-choose-option]').forEach(button => button.addEventListener('click', () => {
        const input = all('[data-ms-option]').find(i => i.dataset.msOption === button.dataset.msChooseOption && i.value === button.dataset.value);
        if (input && !busy) { input.checked = true; input.dispatchEvent(new Event('change', {bubbles: true})); returnToBuy(); }
      }));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => { one('[data-ms-sticky]').hidden = entry.isIntersecting || quick.open; }, {threshold: 0});
        observer.observe(one('.ms-purchase'));
        root.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
      }

      all('[data-ms-fit-open]').forEach(button => button.addEventListener('click', () => openDialog(fit)));
      all('[data-ms-comparison-price]').forEach(el => {
        const variant = variants.find(v => String(v.id) === el.dataset.msComparisonPrice);
        if (variant) el.textContent = money(variant.price);
      });
      if (pdp.fit.kind === 'wrist' && one('[data-ms-measure]') && Number(pdp.fit.min_cm) > 0 && Number(pdp.fit.max_cm) >= Number(pdp.fit.min_cm)) {
        const measure = one('[data-ms-measure]');
        const unit = one('[data-ms-unit]');
        const result = one('[data-ms-fit-result]');
        const positiveMeasurement = value => {
          const raw = value.trim().replace(',', '.');
          if (!/^\d+(?:\.\d+)?$/.test(raw)) return null;
          const number = Number(raw);
          return Number.isFinite(number) && number > 0 ? number : null;
        };
        const rawCm = () => {
          const number = positiveMeasurement(measure.value);
          if (number === null) return null;
          const cm = number * (unit.value === 'in' ? 2.54 : 1);
          return Number.isFinite(cm) ? cm : null;
        };
        const checkFit = () => {
          fitCm = rawCm(); fitIsInside = false;
          one('[data-ms-fit-use]').hidden = true;
          one('[data-ms-fit-saved]').textContent = pdp.fit.prompt;
          if (!measure.value.trim()) { result.textContent = labels.enter_measurement; result.dataset.state = 'empty'; return; }
          if (fitCm === null) { result.textContent = labels.invalid_measurement; result.dataset.state = 'invalid'; return; }
          const min = Number(pdp.fit.min_cm), max = Number(pdp.fit.max_cm);
          fitIsInside = fitCm >= min && fitCm <= max;
          const nearBoundary = unit.value === 'in' && (Math.abs(fitCm - min) <= .13 || Math.abs(fitCm - max) <= .13);
          result.textContent = (nearBoundary ? labels.fit_boundary : fitIsInside ? labels.fit_inside : labels.fit_outside) + ` ${labels.listed_range} ${min}–${max} cm.`;
          result.dataset.state = nearBoundary ? 'boundary' : fitIsInside ? 'inside' : 'outside';
          one('[data-ms-fit-use]').hidden = !fitIsInside || nearBoundary;
        };
        let previousUnit = unit.value;
        unit.addEventListener('change', () => {
          const value = positiveMeasurement(measure.value);
          if (value !== null) {
            const cm = value * (previousUnit === 'in' ? 2.54 : 1);
            if (Number.isFinite(cm)) measure.value = String(Number((unit.value === 'in' ? cm / 2.54 : cm).toFixed(3)));
          }
          previousUnit = unit.value; one('[data-ms-fit-saved]').textContent = pdp.fit.prompt; checkFit();
        });
        measure.addEventListener('input', () => { one('[data-ms-fit-saved]').textContent = pdp.fit.prompt; fitIsInside = false; one('[data-ms-fit-use]').hidden = true; result.textContent = labels.press_check; result.dataset.state = 'empty'; });
        measure.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); checkFit(); } });
        one('[data-ms-fit-check]').addEventListener('click', checkFit);
        one('[data-ms-fit-use]').addEventListener('click', () => {
          if (!fitIsInside) return;
          one('[data-ms-fit-saved]').textContent = `${measure.value} ${unit.value} · ${labels.fit_saved}`;
          closeDialog(fit);
        });
      }

      const request = async (endpoint, options = {}) => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(path(endpoint), {...options, credentials: 'same-origin', signal: controller.signal, headers: {'Accept': 'application/json', ...(options.body ? {'Content-Type': 'application/json'} : {}), ...options.headers}});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || labels.cart_error);
          return data;
        } finally { clearTimeout(timer); }
      };
      const checkoutState = () => { one('[data-ms-checkout]').disabled = busy || cartBusy || !lastCart?.item_count || !!one('[data-ms-checkout]').dataset.submitting; };
      const renderCart = cart => {
        lastCart = cart;
        document.querySelectorAll('.mel-cart-link > span').forEach(badge => { badge.textContent = String(cart.item_count); });
        const list = one('[data-ms-cart-items]'); list.replaceChildren();
        cart.items.forEach(item => {
          const li = document.createElement('li');
          const img = document.createElement('img'); img.width = 60; img.height = 65; img.alt = '';
          if (item.featured_image?.url || item.image) { const url = new URL(item.featured_image?.url || item.image, document.baseURI); url.searchParams.set('width', '140'); img.src = url.href; }
          const detail = document.createElement('div'); const name = document.createElement('strong'); name.textContent = item.product_title || item.title;
          const selection = document.createElement('span'); selection.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          const qty = document.createElement('span'); qty.textContent = `${labels.quantity}: ${item.quantity}`;
          const discounts = document.createElement('span'); discounts.textContent = (item.line_level_discount_allocations || []).map(d => d.discount_application?.title).filter(Boolean).join(' · ');
          detail.append(name, selection, qty, discounts);
          const amount = document.createElement('strong'); const total = item.final_line_price ?? item.line_price;
          if (item.original_line_price > total) { const original = document.createElement('s'); original.textContent = money(item.original_line_price, cart.currency); amount.append(original); }
          amount.append(document.createTextNode(money(total, cart.currency)));
          li.append(img, detail, amount); list.append(li);
        });
        const empty = cart.item_count === 0;
        one('[data-ms-cart-title]').textContent = empty ? labels.empty_cart : labels.your_cart;
        one('[data-ms-cart-status]').textContent = empty ? labels.empty_note : '';
        one('[data-ms-cart-total-row]').hidden = empty;
        one('[data-ms-cart-actions]').hidden = empty;
        one('[data-ms-cart-note]').hidden = empty;
        one('[data-ms-cart-total]').textContent = money(cart.total_price, cart.currency);
        checkoutState();
      };
      const refreshCart = async (showLoading = true) => {
        const sequence = ++cartSequence;
        cartBusy = true; checkoutState();
        if (showLoading) one('[data-ms-cart-status]').textContent = labels.updating_cart;
        try {
          const cart = await request('cart.js?_ms=' + Date.now());
          if (sequence !== cartSequence) return null;
          renderCart(cart);
          return cart;
        } catch (error) {
          if (sequence !== cartSequence) return null;
          lastCart = null;
          one('[data-ms-cart-items]').replaceChildren();
          one('[data-ms-cart-total-row]').hidden = true;
          one('[data-ms-cart-actions]').hidden = true;
          one('[data-ms-cart-note]').hidden = true;
          one('[data-ms-cart-status]').textContent = labels.refresh_error;
          return null;
        } finally { if (sequence === cartSequence) { cartBusy = false; checkoutState(); } }
      };
      const addSelection = async buyNow => {
        if (busy) return;
        const variant = currentVariant(); const qty = quantityValue();
        if (purchaseBlocked || !variant?.available || !qty) return;
        busy = true; paintSelection(variant, false, false); checkoutState();
        one('[data-ms-status]').textContent = labels.adding;
        let added = false;
        try {
          await request('cart/add.js', {method: 'POST', body: JSON.stringify({items: [{id: variant.id, quantity: qty}]})});
          added = true;
          one('[data-ms-status]').textContent = labels.added;
          const cart = await refreshCart();
          if (quick.open) closeDialog(quick);
          openDialog(receipt);
          if (buyNow && cart?.item_count) {
            busy = false;
            one('[data-ms-checkout]').disabled = false;
            one('[data-ms-checkout]').closest('form').requestSubmit(one('[data-ms-checkout]'));
          }
        } catch (error) {
          one('[data-ms-status]').textContent = error.name === 'AbortError' ? labels.add_uncertain : /cannot find variant/i.test(error.message) ? labels.not_ready : error.message || labels.add_error;
          if (!added && error.name === 'AbortError') { await refreshCart(); openDialog(receipt); }
        } finally { busy = false; paintSelection(currentVariant(), false, false); checkoutState(); }
      };
      form.addEventListener('submit', event => { event.preventDefault(); if (!purchaseBlocked) addSelection(false); });
      one('[data-ms-buy-now]').addEventListener('click', () => addSelection(true));
      all('[data-ms-cart-open]').forEach(button => button.addEventListener('click', async () => { openDialog(receipt); await refreshCart(); }));
      one('[data-ms-cart-refresh]').addEventListener('click', () => refreshCart());
      one('[data-ms-checkout]').closest('form').addEventListener('submit', event => {
        const button = one('[data-ms-checkout]');
        if (busy || cartBusy || !lastCart?.item_count || button.dataset.submitting) { event.preventDefault(); return; }
        button.dataset.submitting = 'true';
        button.textContent = labels.opening_checkout;
      });
      if (root.dataset.preview === 'true') {
        const link = one('[data-ms-cart-link]'); const url = new URL(link.href, document.baseURI); url.searchParams.set('preview_theme_id', root.dataset.theme); link.href = url.href;
      }
      const onReturn = () => {
        busy = false;
        delete one('[data-ms-checkout]').dataset.submitting;
        one('[data-ms-checkout]').textContent = labels.checkout;
        const id = new URL(location.href).searchParams.get('variant');
        const variant = variants.find(v => String(v.id) === id) || currentVariant();
        paintSelection(variant, !!variant && String(variant.id) !== nativeSelect.value, false);
        if ([labels.added, labels.adding].includes(one('[data-ms-status]').textContent)) one('[data-ms-status]').textContent = '';
        refreshCart(false);
      };
      window.addEventListener('pageshow', onReturn);
      window.addEventListener('popstate', onReturn);
      window.addEventListener('focus', () => { if (document.visibilityState === 'visible' && !busy) onReturn(); });
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && !busy) onReturn(); });
      one('[data-ms-native]').hidden = true;
      one('[data-ms-options]').hidden = false;
      showImage(imageIndex, false);
      paintSelection(currentVariant(), false, false);
      refreshCart(false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mel-v7-product"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-catalog-product]').forEach(root => {
    if (root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    const parse = selector => { try { return JSON.parse(root.querySelector(selector)?.textContent || 'null'); } catch { return null; } };
    const config = parse('[data-catalog-content]') || {};
    config.images = Array.isArray(config.images) ? config.images : [];
    config.styles = Array.isArray(config.styles) ? config.styles : [];
    const variants = parse('[data-mel-variants]') || [];
    const track = root.querySelector('[data-mel-gallery-track]');
    const slides = [...root.querySelectorAll('[data-mel-slide]')];
    const thumbs = [...root.querySelectorAll('[data-mel-thumb]')];
    const box = root.querySelector('[data-catalog-lightbox]');
    root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !dialog.open) return;
      const items = [...dialog.querySelectorAll('button:not([disabled]), a[href], summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter(item => item.getClientRects().length > 0);
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    }));
    let active = 0;
    let opener;
    const caption = i => config.images.find(x => String(x.media_id).split('/').pop() === slides[i]?.dataset.mediaId)?.caption || slides[i]?.querySelector('img')?.alt || '';
    const announce = i => {
      active = Math.max(0, Math.min(i, slides.length - 1));
      root.querySelector('[data-catalog-caption]').textContent = caption(active);
      root.querySelector('[data-catalog-counter]').textContent = `${slides.length ? active + 1 : 0} / ${slides.length}`;
      root.querySelector('[data-mel-gallery-prev]').disabled = active === 0;
      root.querySelector('[data-mel-gallery-next]').disabled = active >= slides.length - 1;
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === active)));
    };
    const showMedia = id => {
      const i = slides.findIndex(x => x.dataset.mediaId === String(id));
      if (i < 0) return;
      track.scrollTo({left: track.clientWidth * i, behavior: 'instant'});
      announce(i);
    };
    const form = root.querySelector('.mel-product-form');
    const variantInput = root.querySelector('[data-mel-variant-input]');
    const groups = [...root.querySelectorAll('[data-mel-option-group]')];
    const choices = [...root.querySelectorAll('[data-mel-option-choice]')];
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: window.Shopify?.currency?.active || 'USD'});
    const readOptions = () => groups.map(group => group.querySelector(':checked')?.value);
    const sync = (updateUrl = true) => {
      const selected = readOptions();
      const variant = groups.length ? variants.find(v => v.options.every((value, i) => value === selected[i])) : variants[0];
      variantInput.value = variant ? String(variant.id) : '';
      variantInput.disabled = !variant;
      const available = Boolean(variant?.available);
      root.querySelectorAll('[data-mel-add]').forEach(button => { button.disabled = !available; });
      root.querySelectorAll('[data-mel-add-label], [data-mel-sticky-label]').forEach(label => {
        label.textContent = available ? label.dataset.availableLabel : label.dataset.soldLabel;
      });
      root.querySelectorAll('[data-mel-sticky-option]').forEach(label => { label.textContent = groups.length ? selected.join(' / ') : label.dataset.defaultLabel; });
      groups.forEach((group, i) => { const label = group.querySelector('[data-mel-selected-option]'); if (label) label.textContent = selected[i] || ''; });
      choices.forEach(input => {
        const i = Number(input.dataset.melOptionPosition) - 1;
        const exists = variants.some(v => v.options[i] === input.value && v.options.every((value, j) => j === i || value === selected[j]));
        input.setAttribute('aria-disabled', String(!exists));
      });
      const price = root.querySelector('[data-mel-price]');
      price.textContent = variant ? money.format(variant.price / 100) : '—';
      const compare = root.querySelector('[data-mel-compare-price]');
      compare.hidden = !(variant?.compare_at_price > variant?.price);
      compare.textContent = compare.hidden ? '' : money.format(variant.compare_at_price / 100);
      if (updateUrl) {
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
      const style = config.styles.find(s => selected[Number(s.option_position || 1) - 1] === s.option_value);
      const mediaId = style?.media_id || variant?.featured_media?.id || variant?.featured_image?.id;
      if (mediaId) showMedia(String(mediaId).split('/').pop());
    };
    root.addEventListener('change', event => { if (event.target.matches('[data-mel-option-choice]')) sync(); });
    root.querySelector('[data-mel-gallery-prev]').addEventListener('click', () => showMedia(slides[active - 1]?.dataset.mediaId));
    root.querySelector('[data-mel-gallery-next]').addEventListener('click', () => showMedia(slides[active + 1]?.dataset.mediaId));
    thumbs.forEach((button, i) => button.addEventListener('click', () => showMedia(slides[i]?.dataset.mediaId)));
    track.addEventListener('scroll', () => announce(Math.round(track.scrollLeft / (track.clientWidth || 1))), {passive: true});
    root.querySelectorAll('[data-catalog-select]').forEach(button => button.addEventListener('click', () => {
      const style = config.styles.find(x => String(x.id) === button.dataset.catalogSelect);
      const input = choices.find(x => Number(x.dataset.melOptionPosition) === Number(style?.option_position || 1) && x.value === style?.option_value);
      if (input) { input.checked = true; sync(); }
      root.querySelector('.mel-option-groups')?.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      root.querySelector('[data-mel-option-choice]:checked')?.focus({preventScroll: true});
    }));
    const open = (id, target) => {
      const i = slides.findIndex(x => x.dataset.mediaId === String(id));
      if (i < 0) return;
      const img = slides[i].querySelector('img');
      const large = box.querySelector('[data-catalog-large]');
      const url = new URL(img.currentSrc || img.src); url.searchParams.set('width', '1600');
      large.src = url.href; large.alt = img.alt;
      box.querySelector('[data-catalog-large-caption]').textContent = caption(i);
      opener = target; box.showModal(); box.querySelector('button').focus();
    };
    root.querySelector('[data-catalog-zoom]').addEventListener('click', event => { if (slides[active]) open(slides[active].dataset.mediaId, event.currentTarget); });
    root.querySelectorAll('[data-catalog-media]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); open(link.dataset.catalogMedia, link); }));
    box.querySelector('[data-catalog-close]').addEventListener('click', () => box.close());
    box.addEventListener('click', event => { if (event.target === box) box.close(); });
    box.addEventListener('close', () => opener?.focus({preventScroll: true}));
    const materialBox = root.querySelector('[data-mel-material-dialog]');
    const materialTrigger = root.querySelector('[data-mel-material-open]');
    if (materialTrigger && materialBox) {
      materialTrigger.addEventListener('click', () => { materialBox.showModal(); materialBox.querySelector('[data-mel-material-close]').focus(); });
      materialBox.querySelector('[data-mel-material-close]').addEventListener('click', () => materialBox.close());
      materialBox.addEventListener('click', event => { if (event.target === materialBox) materialBox.close(); });
      materialBox.addEventListener('close', () => materialTrigger.focus({preventScroll: true}));
    }
    root.querySelector('[data-mel-fit-open]')?.addEventListener('click', () => {
      const fit = root.querySelector('[data-mel-fit-comparison]');
      if (!fit) return;
      fit.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      fit.focus({preventScroll: true});
    });
    let quantity = 1;
    const changeQuantity = delta => {
      quantity = Math.max(1, Math.min(Number(root.dataset.quantityLimit) || 10, quantity + delta));
      root.querySelector('[data-mel-quantity]').textContent = String(quantity);
      root.querySelector('[data-mel-quantity-input]').value = String(quantity);
    };
    root.querySelector('[data-mel-quantity-minus]').addEventListener('click', () => changeQuantity(-1));
    root.querySelector('[data-mel-quantity-plus]').addEventListener('click', () => changeQuantity(1));
    const wishKey = `mel-wishlist-${root.dataset.productHandle}`;
    let wished = false;
    try { wished = localStorage.getItem(wishKey) === 'true'; } catch {}
    const renderWish = () => root.querySelectorAll('[data-mel-wishlist]').forEach(button => button.setAttribute('aria-pressed', String(wished)));
    root.querySelectorAll('[data-mel-wishlist]').forEach(button => button.addEventListener('click', () => { wished = !wished; try { localStorage.setItem(wishKey, String(wished)); } catch {} renderWish(); }));
    renderWish();
    root.querySelector('[data-mel-scroll-options]').addEventListener('click', () => {
      (groups[0] || form).scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      choices.find(input => input.checked)?.focus({preventScroll: true});
    });
    const sticky = root.querySelector('[data-mel-sticky-cart]');
    const primary = root.querySelector('[data-mel-primary-add]');
    if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    }).observe(primary);
    const footer = document.querySelector('.mel-site-chrome--footer, .mel-footer');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { root.dataset.catalogFooterVisible = String(entry.isIntersecting); }).observe(footer);
    }
    form.addEventListener('submit', event => {
      if (form.dataset.submitting === 'true' || !variants.some(v => String(v.id) === variantInput.value && v.available)) { event.preventDefault(); return; }
      form.dataset.submitting = 'true'; form.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => { delete form.dataset.submitting; form.removeAttribute('aria-busy'); sync(); });
    window.addEventListener('popstate', () => {
      const variant = variants.find(v => String(v.id) === new URL(location.href).searchParams.get('variant'));
      if (variant) choices.forEach(input => { input.checked = variant.options[Number(input.dataset.melOptionPosition) - 1] === input.value; });
      sync(false);
    });
    sync(false); announce(active);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
